import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

interface SessionFormProps {
  handleLogOut: () => void;
  handleStayLoggedIn: () => void;
  remainingTime: number;
  isRenewing?: boolean;
  renewError?: string | null;
}

const SessionForm = ({
  handleLogOut,
  handleStayLoggedIn,
  remainingTime,
  isRenewing = false,
  renewError = null,
}: SessionFormProps) => {
  function millisToMinutesAndSeconds(millis: number) {
    const minutes = Math.floor(millis / 60000);
    const seconds = Number(((millis % 60000) / 1000).toFixed(0));
    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }
  return (
    <Box sx={{ marginTop: '24px', position: 'relative', px: 2 }}>
      {isRenewing && (
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            bgcolor: 'rgba(255, 255, 255, 0.85)',
          }}>
          <CircularProgress size={40} />
          <Typography variant="body2" color="text.secondary">
            Renovando sesión...
          </Typography>
        </Box>
      )}
      <Typography
        color="primary"
        align="center"
        sx={{
          typography: { xs: 'h5', sm: 'h4', md: 'h4', lg: 'h4' },
          fontWeight: { xs: '600', sm: '600', md: '600', lg: '600' },
        }}>
        Tiempo de sesión
      </Typography>
      <Typography
        variant="h5"
        align="center"
        sx={{
          paddingTop: '24px',
          typography: { xs: 'h6', sm: 'h5', md: 'h5', lg: 'h5' },
          fontWeight: { xs: '600', sm: '600', md: '600', lg: '600' },
        }}>
        Tu sesión en linea expirará en
      </Typography>
      <Typography
        variant="h5"
        align="center"
        sx={{
          typography: { xs: 'h6', sm: 'h5', md: 'h5', lg: 'h5' },
          fontWeight: { xs: '600', sm: '600', md: '600', lg: '600' },
        }}>
        {millisToMinutesAndSeconds(remainingTime * 1000)} segs
      </Typography>
      <Typography
        align="center"
        sx={{
          paddingTop: '12px',
          typography: {
            xs: 'body2',
            sm: 'body1',
            md: 'body1',
            lg: 'body1',
          },
        }}>
        {`Has click en "Continuar" para seguir trabajando o en "Salir" para salir ahora.`}
      </Typography>
      {renewError && (
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            mt: 1.5,
            px: 1,
          }}>
          <Tooltip title={renewError} arrow placement="top">
            <IconButton size="small" color="error" aria-label="Detalle del error de renovación">
              <InfoOutlinedIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Typography variant="body2" color="error" align="center">
            No se pudo renovar la sesión.
          </Typography>
        </Stack>
      )}
      <Divider
        orientation="horizontal"
        flexItem
        sx={{ backgroundColor: '#7025c6', marginTop: '24px' }}
      />
      <Stack
        direction="row"
        spacing={3}
        sx={{
          justifyContent: 'center',
          alignItems: 'flex-end',
          margin: '24px 0px 12px',
        }}>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          className="add-button"
          onClick={handleStayLoggedIn}
          disabled={isRenewing}
          sx={{ minWidth: '115px' }}>
          Continuar
        </Button>
        <Button
          variant="contained"
          className="add-button"
          color="error"
          onClick={handleLogOut}
          disabled={isRenewing}
          sx={{ minWidth: '115px' }}>
          Salir
        </Button>
      </Stack>
    </Box>
  );
};

export default SessionForm;
